module.exports = {
          srcSet: __webpack_public_path__ + "c738050d.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "c738050d.jpg",width: 330,height: 241}],
          src: __webpack_public_path__ + "c738050d.jpg",
          toString:function(){return __webpack_public_path__ + "c738050d.jpg"},
          
          width: 330,
          height: 241
        }